import { FC, useEffect, useState } from 'react';
import { Spin, SpinProps } from 'antd';

type LoadingProps = SpinProps & {
  containerClassName?: string;
  style?: React.CSSProperties;
  delay?: number;
};

const Loading: FC<LoadingProps> = ({
  containerClassName = '',
  style,
  delay = 0.5,
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), delay * 1000);
    return () => clearTimeout(timer);
  }, [delay]);

  if (!show) return null;
  return (
    <div
      className={`h-[200px] flex justify-center items-center ${containerClassName}`}
      style={style}
    >
      <Spin />
    </div>
  );
};

export default Loading;
